import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Grid, GridColumn, Selector, Separator, Spinner } from 'telia-front-react';

import { IPrice } from '../stores/models/IPrices';
import { useStores } from '../stores/RootStore';

import Quotas from './Quotas';
import { PrepaymentSteps } from './../Constants';

interface IPriceSelectorProps {
  disabled: boolean;
  setStepIndex: (index: PrepaymentSteps) => void;
}

const PriceSelector = observer((props: IPriceSelectorProps) => {
  const { priceStore, prepaidDataStore } = useStores();
  const translate = React.useContext(TranslationsContext).translate;
  const { disabled, setStepIndex } = props;

  const handleBackButtonClick = () => {
    setStepIndex(PrepaymentSteps.PREPAID_DATA_STEP);
    priceStore.resetStore();
  };

  const handleNextButtonClick = () => {
    setStepIndex(PrepaymentSteps.PAYMENT_STEP);
    priceStore.setCanProceedToPayment(true);
  };

  const renderButtons = (): JSX.Element => {
    return (
      <>
        <Separator spacing="xsmall" color="invisible" />
        <Grid align={['between-xs', 'middle-xs']}>
          <GridColumn width={['xs']} className="text-right">
            <Button size="small" link disabled={disabled} iconLeft="#arrow-left" text={translate('prepaid.steps.previous')} onClick={handleBackButtonClick} />
          </GridColumn>
          <GridColumn width={['xs']}>
            <Button size="small" disabled={disabled} iconRight="#arrow-right" text={translate('prepaid.steps.next')} onClick={handleNextButtonClick} />
          </GridColumn>
        </Grid>
      </>
    );
  };

  const getSelectorItems = (): any[] => {
    return priceStore.priceItems.map((price: IPrice) => ({
      id: `${price.code}`,
      label: `${parseInt(price.price, 10)} €`,
      value: `${price.code}`,
      name: `${price.name}`,
      disabled,
    }));
  };

  if (!priceStore.priceItems || !prepaidDataStore.isStepDone) {
    return null;
  }

  if (prepaidDataStore.loading) {
    return <Spinner />;
  }

  return (
    <>
      <Selector
        id="price-selector"
        size="xlarge"
        label={translate('prepaid.step.price.title')}
        hideLabel={true}
        items={getSelectorItems()}
        value={(priceStore.selectedPrice && priceStore.selectedPrice.code) || null}
        onChange={priceStore.updatePrice}
        itemWidth={['xs-4', 'xl-3']}
      />
      {priceStore.selectedPrice?.quotas && (
        <>
          <Quotas />
        </>
      )}
      {priceStore.selectedPrice && renderButtons()}
    </>
  );
});

export default PriceSelector;
